import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const NESSUNA = 'nessuna';

/** Select delle categorie di costo; "nessuna" = DA CLASSIFICARE. */
export const CategoriaSelect = ({
  valore, categorie = [], onChange, disabled, testid, placeholder,
  className = 'h-8 w-[190px]',
}) => (
  <Select
    value={placeholder && !valore ? undefined : valore || NESSUNA}
    onValueChange={onChange}
    disabled={disabled}
  >
    <SelectTrigger className={`${className} text-xs`} data-testid={testid}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value={NESSUNA}>DA CLASSIFICARE</SelectItem>
      {categorie.map((c) => (
        <SelectItem key={c} value={c}>{c}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export default CategoriaSelect;
